import jQuery from 'jquery';
import { getMountedApps } from 'single-spa';

// Override the jQuery On function to only run in classic
const originalOn = jQuery.fn.on;

jQuery.fn.on = function(elem, types, selector, data, fn, one) {
  let $this = $(this);
  const outerArgs = arguments;

  // This looks to be the only case when the event handler
  // isn't the last argument so something fancy is happening;
  // let's not get in the way.
  // https://github.com/jquery/jquery/blob/master/src/event.js
  if (typeof types === 'object') {
    return originalOn.apply(this, outerArgs);
  }

  // Override only if it's one of our global handlers
  if ($this.is($(window)) || $this.is(document)) {
    let lastArg = outerArgs[outerArgs.length - 1];

    if (typeof lastArg === 'function') {
      const ogFn = lastArg;
      outerArgs[outerArgs.length - 1] = function() {
        if (getMountedApps().includes('classic')) {
          return ogFn.apply(this, arguments);
        }
      };
    }
  }

  return originalOn.apply(this, outerArgs);
};



// WEBPACK FOOTER //
// ./app/scripts/init/monkey-patch-jquery.js